import { Link } from 'react-router-dom';
import useGetGeneralAppData from '../../../../../hooks/useGetGeneralAppData';
import { LineType } from '../../types';
import { Container } from './styles';

interface ListHeaderInterface {
  entity: LineType[];
  apiFetched: boolean;
  filteredEntity: LineType[];
  linkPath: string;
  entityString: { singular: string, plural: string };
}

export default function ListHeader({
  entity,
  apiFetched,
  filteredEntity,
  linkPath,
  entityString,
}: ListHeaderInterface) {
  const { isCustomer, permissions } = useGetGeneralAppData();
  const affreightmentsLinesPermissions = permissions.find((x) => x.codPag === 10);

  return (
    <Container doesListExists={Boolean(entity)} apiFetched={apiFetched}>
      {(entity && apiFetched) && (
        <strong>
          {filteredEntity?.length}
          {' '}
          {filteredEntity?.length === 1 ? entityString.singular : entityString.plural}
        </strong>
      )}
      {!isCustomer && affreightmentsLinesPermissions?.incluir && (
        <Link to={linkPath}>Nova linha</Link>
      )}
    </Container>
  );
}
